import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentComponent } from './content.component';
import {MaterialModule} from '@app/material/material.module';
import {FuseSharedModule} from '@fuse/shared.module';
import { PositiveRewardPreviewComponent } from '../../reward-selector/reward-info/reward-editor/positive-reward-preview/positive-reward-preview.component';
import { NegtiveRewardPreviewComponent } from '../../reward-selector/reward-info/reward-editor/negtive-reward-preview/negtive-reward-preview.component';
import { ImageFormComponent } from './image-form/image-form.component';
import { ImageEditorModule } from '../../shared/components/image-editor/image-editor.module';

@NgModule({
  imports: [
    CommonModule,
    FuseSharedModule,
    MaterialModule,
    ImageEditorModule
  ],
  declarations: [ContentComponent, PositiveRewardPreviewComponent, NegtiveRewardPreviewComponent, ImageFormComponent],
  exports: [ContentComponent, PositiveRewardPreviewComponent, NegtiveRewardPreviewComponent]
})
export class ContentModule { }
